module.exports = __webpack_public_path__ + "static/media/firstTimeHome2.7c55e59b.mp3";